/**
 * Created by Administrator on 2016/12/26.
 */
import * as types from './mutationsType';

export default {
    [types.LOADING] (state, bool) {
        // 对多个接口请求进行计数处理,防止一个接口成功导致loading界面直接停掉
        if (bool === true) {
            ++state.loadingTimes;
        } else if (bool === false) {
            --state.loadingTimes;
        }
        if (state.loadingTimes < 0) {
            state.loadingTimes = 0; // 防止异常
        }
        if (state.loadingTimes > 0) {
            state.loadingShow = true;
        } else {
            state.loadingShow = false;
        }
    },
    [types.NET_ERROR] (state, bool) {
        state.isNetErr = bool;
    },
    [types.RECOVERY_TO_VUEX_UNIONLOGIN] (state, bool) {
        if (bool === true) {
            if (state.IS_FRESH === true) {
                state.IS_FRESH = true;
            }
        }
    }
};



// WEBPACK FOOTER //
// ./src/vuex/mutations.js